export default {
  faqs: {
    data: [],
    meta: {}
  },
  faq: {}
}
